import { connect } from "react-redux";
import Container from "./container";
import { actionCreators as contestActions } from "redux/contest";

const mapStateToProps = (state, ownProps) => {
  const {
    contest: { contestTeams = [], contestUsers = [] }
  } = state;

  return {
    contestTeams,
    contestUsers
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getContestTeams: (contestId) => {
      return dispatch(contestActions.getContestTeams(contestId));
    },
    getContestUsers: (contestId) => {
      return dispatch(contestActions.getContestUsers(contestId));
    },
    updateContestTeamStatus: (contestId, teamId, status) => {
      return dispatch(
        contestActions.updateContestTeamStatus(contestId, teamId, status)
      );
    },
    updateContestUserStatus: (contestId, userId, status) => {
      return dispatch(
        contestActions.updateContestUserStatus(contestId, userId, status)
      );
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
